<template>
    <v-menu left bottom offset-y max-width="500px" :close-on-content-click="false">
        <template v-slot:activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on">
            <v-badge
            color="error"
            bottom
            overlap
            :content="new_alerts"
            :value="new_alerts"
            >
                <v-icon large>mdi-alert-box</v-icon>
            </v-badge>
        </v-btn>
        </template>
        <v-list dark style="max-height: 500px" class="overflow-y-auto" color="#194f73" v-if="alerts.length > 0">
            <v-subheader>
                <span class="font-weight-bold" style="color:white; font-size:large;">Alertes</span>
                <v-spacer></v-spacer>
                <span class="font-weight-bold" style="color:white; font-size:large;">{{ alerts.length }} alertes | {{ new_alerts }} non lues</span>
            </v-subheader>
            <v-divider></v-divider>
            <template v-for="(alert,index) in alerts">
                <v-divider
                v-if="index > 0"
                inset
                :key="index"
                ></v-divider>
                <v-list-item :key="'a'+index">
                    <v-list-item-avatar>
                        <v-badge
                        color="error"
                        dot
                        bottom
                        overlap
                        :value="alert.is_read == false">
                            <v-icon :color="severity_color(alert.severity)">{{ severity_icon(alert.alert_type) }}</v-icon>
                        </v-badge>
                    </v-list-item-avatar>
                    <v-list-item-content>
                        <v-list-item-title>
                            <span :class="!(alert.is_read) ? 'font-weight-bold' : ''">{{ alert.title }}</span>
                            <span class="font-italic" v-if="alert.lift_name"> - {{ alert.lift_name }}</span>
                        </v-list-item-title>
                        <v-list-item-subtitle class="text-wrap">
                            {{ alert.description }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle class="font-italic">
                            {{ format_date(alert.created_at) }}
                        </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                        <div class="d-flex align-center">
                            <v-btn
                            icon
                            small
                            @click.stop="toggleRead(alert)"
                            :title="alert.is_read ? 'Marquer comme non lue' : 'Marquer comme lue'">
                                <v-icon small>{{ alert.is_read ? 'mdi-email-outline' : 'mdi-email-open-outline' }}</v-icon>
                            </v-btn>
                            <v-btn
                            icon
                            small
                            @click.stop="archive(alert)"
                            title="Archiver">
                                <v-icon small>mdi-archive-outline</v-icon>
                            </v-btn>
                            <dialog-infos-task :task="{ description: alert.description }" v-if="alert.task_id"></dialog-infos-task>
                        </div>
                    </v-list-item-action>
                </v-list-item>
            </template>
        </v-list>
        <v-list dark color="#194f73" v-else>
        <v-list-item-content>
            <v-list-item-title>Aucune alerte</v-list-item-title>
        </v-list-item-content>
        </v-list>
    </v-menu>
</template>

<script>
import DialogInfosTask from '@/components/DialogInfosTask'
  export default {
    name: "AlertsCenter",
    components: {
      DialogInfosTask
    },
    data () {
      return {
        pollingInterval: null,
      }
    },
    computed: {
        alerts(){
            return this.$store.state.alertsStore.alerts
        },
        new_alerts(){
            return this.alerts.filter(alert => alert.is_read == false).length
        }
    },
    methods: {
        toggleRead(alert){
            this.$store.dispatch('setAlertReadStatus', { alert_id: alert.alert_id, is_read: !alert.is_read })
        },
        archive(alert){
            this.$store.dispatch('archiveAlert', alert.alert_id)
        },
        severity_icon(alertType){
            if(alertType == 'periodic_check'){
                return 'mdi-calendar-alert'
            }
            return 'mdi-cog-outline'
        },
        severity_color(severity){
            if(severity == 'critical'){
                return 'error'
            }
            if(severity == 'info'){
                return 'info'
            }
            return 'warning'
        },
        format_date(dateStr){
            if(!dateStr){
                return ''
            }
            return new Date(dateStr).toLocaleDateString('fr-FR')
        },
    },
    mounted(){
      // Au chargement : on relance la détection (scanne la base, indépendamment de l'état
      // signé/verrouillé des registres) puis on rafraîchit. Le polling ensuite ne fait que lire.
      this.$store.dispatch('runAlertsDetection')
      this.pollingInterval = setInterval(() => {
          this.$store.dispatch('getAlerts')
      }, 60000)
    },
    beforeDestroy(){
      if(this.pollingInterval){
          clearInterval(this.pollingInterval)
      }
    }
  }
</script>
